
const animationDuration = 0.1
function furnitureAnimationSequence(objectOffMeshes,animationTweenTimeline){
    animationTweenTimeline.fromTo(objectOffMeshes.position, {y:objectOffMeshes.position.y+2},{ duration: animationDuration, y:objectOffMeshes.position.y,onStart:setVisibleTrue,onStartParams:[objectOffMeshes]})
}
function setVisibleFalse(v){
    v.traverse(n=>{
            if(n.isMesh){
                n.visible = false
            }
        })
} 
function setVisibleTrue(i){
    i.traverse(n=>{
        if(n.isMesh){
           n.visible = true
        }
    })
}
   export {
    furnitureAnimationSequence,
    setVisibleFalse,
    setVisibleTrue,
}